import { lazy } from "react";
import Loadable from "app/components/Loadable";

const PublicHolidayList = Loadable(lazy(() => import("./PublicHolidayList")));
const PublicHolidayAdd = Loadable(lazy(() => import("./PublicHolidayAdd")));

const PublicHolidayRoutes = [
  { path: "/ems/public-holidays", element: <PublicHolidayList /> },
  { path: "/ems/public-holidays/:mode/:id", element: <PublicHolidayAdd /> },
];

export default PublicHolidayRoutes;
